import {map, mergeMap} from 'rxjs/operators';
import {ofType} from 'redux-observable-es6-compat';
import {ASetPlayrules} from '../actions/playrule.action';
import {TRemote} from '../actions';

export const fetchPlayrulesEpic = (action$, _, {restApi}) =>
  action$.pipe(
    ofType(TRemote.SET_REMOTE),
    mergeMap(() => restApi.get(`/tempo`, 15000)),
    map(ASetPlayrules)
  );
